import FreeShippingIcon from "@components/Icons/FreeShippingIcon";

const FreeShippingPromoMessage = () => (
  <div className="flex items-center gap-4 rounded-lg bg-[#F5FBF4] p-[8px]">
    <div className="flex p-[8px] items-center justify-center rounded-full bg-[#F6F6F6]">
      <FreeShippingIcon />
    </div>
    <p className="text-[#319D10] text-[14px]">
      Felicitari! Beneficiezi de transport gratuit datorita comenzilor tale
      recente.
    </p>
  </div>
);

export default FreeShippingPromoMessage;
